/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitLogoListByCompanyId,
    PressKitLogoListByCompanyIdFromJSON,
    PressKitLogoListByCompanyIdFromJSONTyped,
    PressKitLogoListByCompanyIdToJSON,
} from './PressKitLogoListByCompanyId';

/**
 * 
 * @export
 * @interface GetPressKitLogoListResponse
 */
export interface GetPressKitLogoListResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitLogoListResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitLogoListResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitLogoListByCompanyId}
     * @memberof GetPressKitLogoListResponse
     */
    data: PressKitLogoListByCompanyId;
}

export function GetPressKitLogoListResponseFromJSON(json: any): GetPressKitLogoListResponse {
    return GetPressKitLogoListResponseFromJSONTyped(json, false);
}

export function GetPressKitLogoListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitLogoListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitLogoListByCompanyIdFromJSON(json['data']),
    };
}

export function GetPressKitLogoListResponseToJSON(value?: GetPressKitLogoListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitLogoListByCompanyIdToJSON(value.data),
    };
}

